import { render } from "./ErrorView.vue?vue&type=template&id=d6a50700&scoped=true"
import script from "./ErrorView.vue?vue&type=script&lang=js"
export * from "./ErrorView.vue?vue&type=script&lang=js"

import "./ErrorView.vue?vue&type=style&index=0&id=d6a50700&lang=scss&scoped=true"

import exportComponent from "E:\\Fadi\\Projects\\Vuejs\\my-protfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6a50700"]])

export default __exports__